import {useEffect, useState, Fragment} from 'react'
import {fromJS} from 'immutable'
import PropTypes from 'prop-types'

import CodeVerification from './CodeVerification'
import OtpDeliverySelection from './OtpDeliverySelection'

import {findResourceByAttributeId} from '../../../../lib/plan_data/userData'
import {dasherize} from '../../../../lib/integrationTools'
import preAuthHook from '../../lib/preAuthHook'
import SessionStore from '../../stores/SessionStore'
import SignInActions from '../../actions/SignInActions'
import {useNotificationContext} from '../../../../shared_components/notifications/NotificationContext'


const TfaSecondarySignIn = props => {
  const [step, setStep] = useState(SessionStore.getState().codeSentToPrimary ? 'verification' : 'delivery')
  const [method, setMethod] = useState('text')
  const [error, setError] = useState(SessionStore.getState().signInError)
  const [loading, setLoading] = useState(false)
  const [trustMe, setTrustMe] = useState(false)
  const {alwaysNotify} = useNotificationContext()
  const tfaEnrollments = fromJS(SessionStore.getState().enrollments?.map(enrollment => dasherize(enrollment)) || [])
  const tfaEnrollment = findResourceByAttributeId({resourceList: tfaEnrollments, attribute: 'mode', id: 'phone'})

  const onUpdate = () => {
    const signInError = SessionStore.getState().signInError

    setError(signInError)
    if (signInError) setLoading(false)
  }

  useEffect(() => {
    preAuthHook()
    setError(null)
    SessionStore.addChangeListener(onUpdate)
    return () => {
      SessionStore.removeChangeListener(onUpdate)
    }
  }, [])

  const selectDeliveryOption = option => {
    const email = SessionStore.getState().preAuthEmail
    const password = SessionStore.getState().preAuthPassword

    setStep('verification')
    setMethod(option)
    SignInActions.signInSecondary(email, password, option)
  }

  const verifyCode = formData => {
    const codeSentToPrimary = SessionStore.getState().codeSentToPrimary
    const primaryPhone = SessionStore.getState().primaryPhone
    const phoneType = codeSentToPrimary ? 'primary' : 'secondary'
    const deliveryMethod = codeSentToPrimary ? primaryPhone.preferred_message_mode : method
    const authenticationMethod = `${phoneType}_phone_${deliveryMethod}`

    setError(null)
    setLoading(true)
    SignInActions.signInWithCode({
      ...formData,
      email: SessionStore.getState().preAuthEmail,
      password: SessionStore.getState().preAuthPassword,
      enrollmentId: tfaEnrollment.get('id'),
      phoneId: codeSentToPrimary ?
        SessionStore.getState().primaryPhone?.id :
        SessionStore.getState().secondaryPhone?.id,
      trustMe,
      authenticationMethod
    })
  }

  const resendCode = event => {
    if (event) event.preventDefault()

    const email = SessionStore.getState().preAuthEmail
    const password = SessionStore.getState().preAuthPassword

    if (SessionStore.getState().codeSentToPrimary)
      SignInActions.signInPrimaryPhone({email, password, phoneId: SessionStore.getState().primaryPhone?.id})
    else
      SignInActions.signInSecondary(email, password, method)

    if (SessionStore.getObfuscatedPrimaryNumber() || SessionStore.getObfuscatedSecondaryNumber())
      alwaysNotify.shortSuccess(`Resent code to ${SessionStore.getState().codeSentToPrimary ? SessionStore.getObfuscatedPrimaryNumber() : SessionStore.getObfuscatedSecondaryNumber()}.`)
    else
      alwaysNotify.shortError(SessionStore.getState().signInError || 'Unable to resend code.')
  }

  const toggleTrustMe = () => setTrustMe(!trustMe)

  return (
    <Fragment>
      {
        step === 'delivery' ?
          (
            <OtpDeliverySelection
              selectDeliveryOption={selectDeliveryOption}
              obfuscatedPhoneNumber={SessionStore.getObfuscatedSecondaryNumber()}
            />
          ) :
          (
            <CodeVerification
              error={error}
              loading={loading}
              trustMe={trustMe}
              logMixpanelEvent={props.logMixpanelEvent}
              toggleTrustMe={toggleTrustMe}
              tfaEnrollment={tfaEnrollment}
              verifyCode={verifyCode}
              resendCode={resendCode}
              obfuscatedPhoneNumber={SessionStore.getState().codeSentToPrimary ? SessionStore.getObfuscatedPrimaryNumber() : SessionStore.getObfuscatedSecondaryNumber()}
            />
          )
      }
    </Fragment>
  )
}

TfaSecondarySignIn.propTypes = {
  logMixpanelEvent: PropTypes.func.isRequired
}

export default TfaSecondarySignIn
